import * as React from "react"
import trans from "trans"
import { connect } from "react-redux"
import * as NumericInputField from "react-numeric-input";

import { css, GridCell, Grid, Select, Toggler } from "@bdfx/mergado-ui-kit"

import {
    getHidingFilters as apiGetAvailableFilters,
} from "app/helpers/api";

import {SettingsSpinner} from "./spinner";

import {
    updateInputValue as change,
    initForm
} from "app/reducers/form";

import {SettingsFormType} from "app/types/model-types";

import {isMultiSelectCloseOnChange} from "products/components/filters";
import { selectFormValues } from "app/reducers/form";

interface Props {
    change: typeof change
    settingsForm: SettingsFormType
    saveSettingsDebounced: Function
}

interface State {
    hidingFilters: {
        status_codes_for_hiding_elements: number[]
        mime_types_for_hiding_elements: string[]
    }
    isLoading: boolean
}

class HidingRules extends React.Component<Props, State> {
    constructor(props) {
        super(props)

        this.state = {
            hidingFilters: null,
            isLoading: false,
        }
    }

    componentDidMount(): void {
        this.setState({isLoading: true})

        apiGetAvailableFilters()
            .then((response: any) => {
                this.setState({hidingFilters: response.data})
            })
            .catch(error => {
                console.debug('error while getting ', error)
            })
            .finally(() => {
                this.setState({isLoading: false})
            })
    }

    render() {
        const {isLoading, hidingFilters} = this.state

        if (isLoading) {
            return (
                <SettingsSpinner />
            )
        }

        const availableStatusCodes = hidingFilters ? hidingFilters.status_codes_for_hiding_elements.map((o : number) => {
            return {
                label: `${o}`,
                value: `${o}`,
            }
        }) : []

        return (
            <div style={{ paddingBottom: '20px', textAlign: 'left' }}>
                <h4>{trans('hide_products_by_filter')}</h4>

                <ListGrid>
                    <GridCell>{trans('filter_status_code')}</GridCell>
                    <GridCell className={'right'}>
                        <Select
                            multiple={true}
                            closeOnChange={isMultiSelectCloseOnChange}
                            name={`settingsForm.hide_by_status_code`}
                            options={availableStatusCodes}
                            onChange={() => this.props.saveSettingsDebounced()}
                        />
                    </GridCell>

                    <GridCell>{trans('filter_empty_content')}</GridCell>
                    <GridCell className={'right'}>
                        <Toggler
                            big={true}
                            boolean={true}
                            name={`settingsForm.hide_by_is_empty`}
                            from={''}
                            onLabel={''}
                            offLabel={''}
                            title={trans('filter_empty_content')}
                            onChange={() => this.props.saveSettingsDebounced()}
                        />
                    </GridCell>

                    <GridCell>{trans('filter_no_image')}</GridCell>
                    <GridCell className={'right'}>
                        <Toggler
                            big={true}
                            boolean={true}
                            name={`settingsForm.hide_by_no_image`}
                            from={''}
                            onLabel={''}
                            offLabel={''} title={trans('filter_no_image')}
                            onChange={() => this.props.saveSettingsDebounced()}
                        />
                    </GridCell>

                    <GridCell>{trans('hide_by_has_watermark')}</GridCell>
                    <GridCell className={'right'}>
                        <Toggler
                            big={true}
                            boolean={true}
                            name={`settingsForm.hide_by_has_watermark`}
                            from={''}
                            onLabel={''}
                            offLabel={''}
                            title={trans('hide_by_has_watermark')}
                            onChange={() => this.props.saveSettingsDebounced()}
                        />
                    </GridCell>

                    <GridCell>{trans('hide_by_wrong_placement')}</GridCell>
                    <GridCell className={'right'}>
                        <Toggler
                            big={true}
                            boolean={true}
                            name={`settingsForm.hide_by_wrong_placement`}
                            from={''}
                            onLabel={''}
                            offLabel={''}
                            title={trans('hide_by_wrong_placement')}
                            onChange={() => this.props.saveSettingsDebounced()}
                        />
                    </GridCell>

                    <GridCell>{trans('hide_by_low_quality')}</GridCell>
                    <GridCell className={'right'}>
                        <Toggler
                            big={true}
                            boolean={true}
                            name={`settingsForm.hide_by_low_quality`}
                            from={''}
                            onLabel={''}
                            offLabel={''}
                            title={trans('hide_by_low_quality')}
                            onChange={() => this.props.saveSettingsDebounced()}
                        />
                    </GridCell>

                    <GridCell>{trans('filter_content_length_gt')}</GridCell>
                    <GridCell>
                        <StyledNumericInputDiv>
                            <NumericInputField
                                precision={0}
                                value={this.props.settingsForm.hide_by_content_length_gt}
                                min={0}
                                step={100}
                                title={trans('filter_content_length_gt')}
                                onChange={(e) => {
                                    this.props.change('settingsForm', 'hide_by_content_length_gt', e)
                                    this.props.saveSettingsDebounced()
                                }}
                                snap
                            />
                        </StyledNumericInputDiv>
                    </GridCell>

                    <GridCell>{trans('filter_content_length_lt')}</GridCell>
                    <GridCell>
                        <StyledNumericInputDiv>
                            <NumericInputField
                                precision={0}
                                value={this.props.settingsForm.hide_by_content_length_lt}
                                min={0}
                                step={100}
                                title={trans('filter_content_length_lt')}
                                onChange={(e) => {
                                    this.props.change('settingsForm', 'hide_by_content_length_lt', e)
                                    this.props.saveSettingsDebounced()
                                }}
                                snap
                            />
                        </StyledNumericInputDiv>
                    </GridCell>
                </ListGrid>               
            </div>
        )
    }
}

const ListGrid = css(Grid)({
    gridTemplateColumns: 'max-content max-content',
    paddingTop: '30px',
    gap: '10px',
    ' .muk-icon.no-text': {
        lineHeight: '1em',
    },
    ' .no-text.muk-icon--close': {
        paddingTop: '5px',
    },
    ' .no-text.muk-icon--check': {
        paddingTop: '5px',
    },
    ' .right': {
        justifySelf: 'right',
    }
})

export const StyledNumericInputDiv = css('div')({
    paddingRight: '10px',
    width: '100%',
    ' .react-numeric-input': {
        width: '100%',
    },
    ' input': {
        width: '100%',
        textAlign: 'right',
        height: '40px',
        paddingRight: '40px !important',
    },
    ' span.react-numeric-input b': {
        fontSize: '20px',
    }
})

function mapStateToProps(state) {
    return {
        settingsForm: selectFormValues(state,'settingsForm'),
    }
}

export default connect(mapStateToProps, {
    change,
})(HidingRules)
